<template>
    <div>
        <el-row :gutter="15">
            <el-col :sm="24" :md="24" :lg="24" class="mb-2 mb-lg-10">
                <div class="card card-lift shadow border-1 card-strategy1">
                    <img src="img/strategy/strategy1.svg" class="image_strategy1">
                    <span class="card_span_strategy1 vertical-center">{{$t('strategy.yunalish1')}}</span>
                </div>
            </el-col>
            <el-col :sm="24" :md="24" :lg="24" class="mb-2 mb-lg-10">
                <div class="card card-lift shadow border-1 card-strategy2">
                    <img src="img/strategy/strategy2.svg" class="image_strategy1">
                    <span class="card_span_strategy1 vertical-center">{{$t('strategy.yunalish2')}}</span>
                </div>
            </el-col>
            <el-col :sm="24" :md="24" :lg="24" class="mb-2 mb-lg-10">
                <div class="card card-lift shadow border-1 card-strategy3">
                    <img src="img/strategy/strategy3.svg" class="image_strategy1">
                    <span class="card_span_strategy1 vertical-center">{{$t('strategy.yunalish3')}}</span>
                </div>
            </el-col>
            <el-col :sm="24" :md="24" :lg="24" class="mb-2 mb-lg-10">
                <div class="card card-lift shadow border-1 card-strategy4">
                    <img src="img/strategy/strategy4.svg" class="image_strategy1">
                    <span class="card_span_strategy1 vertical-center">{{$t('strategy.yunalish4')}}</span>
                </div>
            </el-col>
            <el-col :sm="24" :md="24" :lg="24" class="mb-2 mb-lg-10">
                <div class="card card-lift shadow border-1 card-strategy5">
                    <img src="img/strategy/strategy5.svg" class="image_strategy1">
                    <span class="card_span_strategy1 vertical-center">{{$t('strategy.yunalish5')}}</span>
                </div>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-col :sm="12" :md="8" :lg="4" class="mb-3 mb-lg-10" style="float: right;">
                <a href="/ustuvor_yo'nalishlar.pdf" target="_blank">
                    <div class="card card-lift shadow border-0 card-strategy_link">
                        <img src="img/strategy/pdf_file.svg" class="image_strategy_link">
                        <span class="card_span_strategy_link vertical-center">{{$t('general.download')}}</span>
                    </div>
                </a>
            </el-col>
            <el-col :sm="12" :md="8" :lg="4" class="mb-3 mb-lg-10" style="float: right;">
                <a href="https://lex.uz/" target="_blank">
                    <div class="card card-lift shadow border-0 card-strategy_link">
                        <img src="img/strategy/lex_logo.png" class="image_strategy_link">
                        <span class="card_span_strategy_link vertical-center">Lex.uz</span>
                    </div>
                </a>
            </el-col>
            <el-col :sm="12" :md="8" :lg="4" class="mb-3 mb-lg-10" style="float: right;">
                <a href="https://strategy.uz/index.php" target="_blank">
                    <div class="card card-lift shadow border-0 card-strategy_link">
                        <img src="img/ill/strategy.png" class="image_strategy_link">
                        <span class="card_span_strategy_link vertical-center">{{$t('strategy.title')}}</span>
                    </div>
                </a>
            </el-col>
        </el-row>
        <el-row :gutter="15">
            <el-col :sm="24" :md="24" :lg="24" class="mb-3 mb-lg-10" style="float: right;">
                <div class="card card-lift shadow border-0 card-info_strategy">
                    <strong class="card_info_title">{{$t('strategy.strategy_title')}}</strong>
                    <strong class="card_info_title">{{$t('strategy.strategy_title1')}}</strong>
                    <strong class="card_info_title">{{$t('strategy.strategy_title2')}}</strong>
                    <div style="overflow: auto; height: 400px; margin-top: 8px;">
                            <span class="card_span_strategy_text">
                                <strong v-html="$t('strategy.strategy_title2_text')"></strong>
                                <span v-html="$t('strategy.strategy_title2_info')"></span>
                            </span>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "MainPagePanel2"
    }
</script>

<style scoped>
    @import url(../../../assets/css/custom.scss);

    hr {

        border: none;
        border-left: 1px solid #00b0f0;
        height: 14px;
        margin: 4px 5px;
        width: 1px;
    }

    blockquote {
        margin: 0 0 0rem;
    }

    .button_new_m {
        display: block;
        white-space: inherit;
        line-height: 1;
        font-weight: 500;
        margin-right: 0px !important;
        margin-left: 0px !important;
    }

    .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 150px;
        margin: 0;
    }

    .el-carousel__item:nth-child(2n) {
        background-color: transparent;
    }

    .el-carousel__item:nth-child(2n+1) {
        background-color: transparent;
    }

    .st1 {
        fill: #96b4d3;
        stroke: #fff;
        stroke-miterlimit: 10;
    }

    .st1:hover {
        fill: #04ad00;
        cursor: pointer;
    }

    .st1.active {
        fill: #21ad69;
    }
</style>